const MUIZK_AIR = process.env.VUE_APP_MUIZK_AIR
const MUZIK_DOMAIN = process.env.VUE_APP_MUZIK_DOMAIN
// Lazy loading
const Layout = () => import(/* webpackChunkName: "Layout" */ '@/layouts/Layout')
const AIR = () => import(/* webpackChunkName: "AIR" */ '@/pages/_locale/AIR')
const airMetaImage = `https://${MUIZK_AIR}.${MUZIK_DOMAIN}/img/cover-social/air.png`

const airRoutes = [
  {
    path: '/:locale/air',
    component: Layout,
    children: [
      {
        path: '',
        name: 'air',
        component: AIR,
        meta: {
          requiresAuth: false,
          breadcrumbs: [],
          metaInfo: {
            title: 'AIR.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: airMetaImage },
              { vmid: 'og:image', name: 'og:image', content: airMetaImage }
            ]
          }
        }
      }
    ]
  }
]

export default airRoutes
